import axios from 'axios';

/**
 * API call to fetch a templates handbook's Summary of Changes
 *
 * @method fetchTemplatesSummaryOfChangesAPI
 * @param  {string} changeId The changeId of the template
 * @return {Promise}
 */
export function fetchTemplatesSummaryOfChangesAPI(changeId) {
    return axios({
        method: 'get',
        url: `/throne/handbook/v1/master-handbook/linked-handbooks/${changeId}/policy-alerts`,
        type: 'zend',
    });
}

export function acceptTemplatesSummaryOfChangesAPI(changeId) {
    return axios({
        method: 'post',
        url: `/throne/handbook/v1/master-handbook/linked-handbooks/${changeId}/policy-alerts/accept`,
        type: 'zend',
    });
}

/**
 * API call to send handbook reminder.
 *
 * @method sendHandbookReminderAPI
 * @param  {string} handbookId The handbookId of the template
 * @return {Promise}
 */
export function sendHandbookReminderAPI(handbookId) {
    return axios({
        method: 'post',
        url: `/throne/handbook/v1/master-handbook/${handbookId}/send-admin-email`,
        type: 'zend',
    });
}

/**
 * API call to fetch linked handbooks by policy.
 *
 * @method fetchLinkedHandbooksByPolicyAPI
 * @param {Object} payload The policy object to filter linked handbooks
 * @return {Promise}
 */
export function fetchLinkedHandbooksByPolicyAPI(payload) {
    return axios({
        method: 'get',
        url: `/throne/handbook/v1/master-handbook/${payload.policyType}/policies/${payload.policyId}/linked-handbooks`,
        type: 'zend',
        params: payload,
    });
}
